angular.module('lsnBase.arrayUnique', []);